import { useSelector } from 'react-redux';
import useMarketedPromotions from 'bento-ordering/promotions/hooks/useMarketedPromotions';

function useUnlockedPromotionByLastAction() {
  const previousPromotionsState = useSelector(
    state => state.promotions.previousState
  );
  const promotions = useMarketedPromotions();
  if (!previousPromotionsState.byId) {
    return null;
  }
  return promotions.reduce((acc, curr) => {
    const previousPromotion = previousPromotionsState.byId[curr.id];
    if (
      curr.unlocked &&
      previousPromotion &&
      !previousPromotion.unlocked &&
      acc === null
    ) {
      return curr;
    }
    return acc;
  }, null);
}

export default useUnlockedPromotionByLastAction;
